import React from 'react';

/*
  THE SIGN-IN MESSAGE LABELS, rebrand step 7, 17 September 2026 (brand guide
  9.8), ported from the approved reference.

  A tilted shipping label with a postmark seal stamped on its top-right corner.
  It says what happened in the words the guide gives, and it is a live region,
  so somebody using a screen reader is told the same thing at the same time.

  | | Success | Failure |
  |---|---|---|
  | Band | MedEx gold, navy words | Error red, white words |
  | Headline | Signed in! | Sorry, your shipment's delayed. |
  | Seal | a check | an X |

  It carries no from, no to, no tracking number and no logo, which the guide
  rules out by name.
*/

const COPY = {
  success: {
    band: 'Priority overnight',
    title: 'Signed in!',
    message: 'Your dashboard is out for delivery.',
  },
  error: {
    band: 'Return to sender',
    title: "Sorry, your shipment's delayed.",
    message: 'Double check your email and password below.',
  },
};

/* The barcode along the bottom of the label: the reference's own bar widths. */
const BARS = [6, 3, 9, 3, 3, 12, 4, 7, 3, 10, 3, 6, 4, 9, 3, 5, 11, 3, 7, 4];

export default function ShipLabel({ kind, shown }) {
  const copy = COPY[kind] || COPY.success;
  const ring = copy.band.toUpperCase() + '      ONHAND      ';
  return (
    <div className={'signin-label' + (kind === 'error' ? ' is-error' : '') + (shown ? ' is-shown' : '')}
      role="status" aria-live="polite">
      <div className="signin-label-paper-wrap">
        <div className="signin-label-paper">
          <div className="signin-label-band"><span>{copy.band}</span></div>
          <div className="signin-label-body">
            <h2>{copy.title}</h2>
            <p>{copy.message}</p>
            <div className="signin-label-bars" aria-hidden="true">
              {BARS.map((w, i) => <span key={i} style={{ width: w + 'px' }} />)}
            </div>
          </div>
        </div>
        <svg className="signin-seal" viewBox="0 0 320 320" aria-hidden="true">
          <defs>
            <path id={'sealArc-' + kind} d="M160 160m-122 0a122 122 0 1 1 244 0a122 122 0 1 1 -244 0" />
          </defs>
          <circle cx="160" cy="160" r="150" className="signin-seal-bg" />
          <circle cx="160" cy="160" r="98" className="signin-seal-ring" />
          <text className="signin-seal-text">
            <textPath href={'#sealArc-' + kind} startOffset="0">{ring}</textPath>
          </text>
          {kind === 'error'
            ? <path className="signin-seal-mark" d="M122 122L198 198M198 122L122 198" />
            : <path className="signin-seal-mark" d="M112 164L145 196L210 128" />}
        </svg>
      </div>
    </div>
  );
}
